import React, { useState, useEffect, forwardRef } from 'react';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import { Dropdown, Pagination } from 'flowbite-react';
import { FaFilter } from 'react-icons/fa'; // Import the filter icon from react-icons
import ClipLoader from 'react-spinners/ClipLoader';
import { FaInfoCircle } from 'react-icons/fa';
import moment from 'moment'
import { Button, Modal } from "flowbite-react";
import { RiAiGenerate } from "react-icons/ri";
import { IoCreate } from "react-icons/io5";
import ListingStats from './ListingStats';
import { IoPerson } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { FaGoogle, FaYahoo, FaMicrosoft, FaCopy } from "react-icons/fa";
import { Link } from 'react-router-dom';


const Listings = () => {
  const [selectedItem, setSelectedItem] = useState(null); // State to store the selected item
  const { user } = useAuth0();
  const [fetchedUser, setUser] = useState(null);
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const [searchQuery, setSearchQuery] = useState(''); // Add state for search query
  const [filterOption, setFilterOption] = useState(true); // State to manage the filter toggle
  const [currentPage, setCurrentPage] = useState(1); // State to manage the current page
  const itemsPerPage = 10; // Number of items per page
  const [openModal, setOpenModal] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [replyContent, setReplyContent] = useState("");
  const [generatedDraft, setGeneratedDraft] = useState(''); // State to store the generated draft
  const [loadingEmail, setLoadingEmail] = useState(false); // State to track loading status
  const [filterByDeadline, setFilterByDeadline] = useState(false); // Track filter by deadline
  const [filterByNew, setFilterByNew] = useState(true);
  const [searchOption, setSearchOption] = useState('Title'); // State for dropdown selection
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();


  const cacheKeyListings = 'cachedListings';
  const cacheTimestampKey = 'cacheTimestamp';
  const cacheDuration = 1000 * 60 * 1; // 8 minute

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        console.log('Fetching user data');
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/user-settings`, {
          params: {
            sub: user.sub
          }
        });
        console.log('The response:', response);
        if (response.data === 'No user found') {
          console.log('set user to null');
          setUser(null);
          setLoading(false); // Set loading to false in case of error
        } else {
          console.log('the user found', response.data);
          setUser(response.data);

          //check if user has completed profile i.e industry/expertise
          if (response.data.expertise.length < 1 || response.data.industry.length < 1) {
            setLoading(false); // Set loading to false
            console.log('user needs to complete profile')
            setUser(null)
          }
          if (response.data.expertise.length > 1 && response.data.industry.length > 1) {
            const cachedListings = localStorage.getItem(cacheKeyListings);
            const cachedTimestamp = localStorage.getItem(cacheTimestampKey);
            const now = new Date().getTime();

            if (cachedListings && cachedTimestamp && now - cachedTimestamp < cacheDuration) {
              // Use cached listings
              setListings(JSON.parse(cachedListings));
              setLoading(false); // Set loading to false
              // Check if cache needs to be refreshed
              if (now - cachedTimestamp >= cacheDuration / 2) {
                // Refresh cache in the background
                refreshCache(response.data);
              }
            } else {
              // Fetch new listings
              fetchListingsWithPolling(response.data);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        setLoading(false); // Set loading to false in case of error
      }
    };

    fetchUserData();
  }, [user.sub]);

  const fetchListingsWithPolling = async (userData) => {
    const pollInterval = 1000; // 5 seconds
    let polling = true;
  
    setLoading(true); // Set loading to true at the start
  
    while (polling) {
      try {
        console.log('Fetching matched listings', userData.sub);
        const sub = userData.sub;
        const listingsResponse = await axios.get(`${process.env.REACT_APP_MATCHING_BACKEND_URL}/api/match`, {
          params: { sub },
        });
  
        if (listingsResponse.data && listingsResponse.data.length > 0) {
          console.log('Listings found:', listingsResponse.data);
          setListings(listingsResponse.data);
          localStorage.setItem(cacheKeyListings, JSON.stringify(listingsResponse.data));
          localStorage.setItem(cacheTimestampKey, new Date().getTime().toString());
          polling = false; // Stop polling when listings are found
        } else {
          console.log('No listings yet, polling again in 1 seconds...');
        }
      } catch (error) {
        console.error('Error fetching listings:', error);
        polling = false; // Stop polling if there’s an error
      }
  
      if (polling) {
        await new Promise((resolve) => setTimeout(resolve, pollInterval)); // Wait before the next poll
      }
    }
  
    setLoading(false); // Set loading to false when polling ends
  };

  const refreshCache = async (userData) => {
    try {
      console.log('Refreshing cache');
      const sub = userData.sub
      console.log('the sub cache found', sub)
      const listingsResponse = await axios.get(`${process.env.REACT_APP_MATCHING_BACKEND_URL}/api/match`, {
        params: {
          sub: sub
        }
      });
      console.log('The listings response:', listingsResponse);
      setListings(listingsResponse.data);
      localStorage.setItem(cacheKeyListings, JSON.stringify(listingsResponse.data));
      localStorage.setItem(cacheTimestampKey, new Date().getTime().toString());
    } catch (error) {
      console.error('Error refreshing cache:', error);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    console.log('Search Query:', e.target.value); // Log the search query
  };

  const toggleFilterOption = () => {
    setFilterOption(!filterOption);
    setCurrentPage(1); // Reset pagination to page 1

  };
  const generateContent = async(reply, expertise, listing) => {
    setLoadingEmail(true)
    let itemSelected = selectedItem
    console.log('item seleteced', itemSelected)
    const response = await axios.post(`${process.env.REACT_APP_MATCHING_BACKEND_URL}/generate-email`, {
        reply: reply,
        expertise: expertise,
        listing: itemSelected.listing.description
    })
      // Assuming the server returns the generated draft
      const { emailDraft } = response.data;
      setGeneratedDraft(emailDraft); // Set the generated draft in state
    setLoadingEmail(false)
  }

  const onPageChange = (page) => {
    console.log('Page changed to:', page); // Debugging log
    setCurrentPage(page);
  };

  const generateSlug = (title) =>
    title
      .toLowerCase() // Convert to lowercase
      .trim() // Remove leading/trailing spaces
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/[^\w-]+/g, ''); // Remove non-alphanumeric characters (except hyphens)
  

  const filteredListings = listings.filter(listing => {
    const matchesSearchQuery = searchOption === 'Title' 
      ? listing.listing.title.toLowerCase().includes(searchQuery.toLowerCase()) 
      : listing.listing.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilterOption = filterOption ? listing.matchScore > 50 : true;
    const matchesNewFilter = filterByNew ? moment(listing.listing.posted).isAfter(moment().subtract(7, 'days')) : true; 
    const matchesDeadlineFilter = filterByDeadline ? moment(listing.listing.deadline).isBefore(moment().add(1, 'days')) : true;
  
    return matchesSearchQuery && matchesFilterOption && matchesNewFilter && matchesDeadlineFilter;
  });
  

  const paginatedListings = filteredListings.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const getMatchColor = (matchScore) => {
    if (matchScore >= 50) {
      return 'bg-green-600';
    } else if (matchScore >= 50) {
      return 'bg-orange-600';
    } else {
      return 'bg-red-600';
    }
  };

  if (loading) {
    return <div style={{
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column', // Stack items vertically
      alignItems: 'center',
      height: '100vh'
    }}>
      <ClipLoader color="#3498db" />
      <span style={{ marginTop: '10px', fontSize: '16px', color: '#555' }}>
        Loading your matches...
      </span>
    </div>
  }

  const handleGenerateClick = (item) => {
    console.log('the item', item)
    setSelectedItem(item); // Set the selected item when the "Generate" button is clicked
    setOpenModal(true); // Open the modal
  };

  return (
    <div className="dashboard-main relative overflow-x-auto sm:rounded-lg">
      <ListingStats/>
      <caption className="p-5 text-lg font-semibold text-left text-gray-900 bg-white dark:text-white dark:bg-gray-800">
      <p className="mt-1 text-sm font-normal text-gray-500 dark:text-gray-400">
        Browse a list of matched listings based on your profile.
      </p>
      <form className="max-w-full ml-0 mt-4 w-full"> {/* Make form full width */}
      <div className="flex items-center w-full"> {/* Make flex container full width */}
        
        {/* Title button */}
        <Dropdown
          className="rounded-e-lg border border-gray-300"
          style={{
            background: 'white',
            borderRight: 'none',
            border: '1px solid #d1d5db', 
            color: 'black',
            borderRadius: "5px 0 0 5px"
          }}
          label={<span>{searchOption}</span>}
          onChange={(e) => setSearchOption(e.target.value)} // Update the selected filter option
          dismissOnClick={false}
        >
          <Dropdown.Item onClick={() => setSearchOption('Title')}>Title</Dropdown.Item>
          <Dropdown.Item onClick={() => setSearchOption('Description')}>Description</Dropdown.Item>
        </Dropdown>

        {/* Search input (reduced width and no margin between Title button) */}
        <div className="relative w-[180px]"> {/* Set a smaller width for the search input */}
          <input
            value={searchQuery}
            onChange={handleSearchChange}
            type="search"
            id="search-dropdown"
            className="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-e-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-700 dark:text-white dark:focus:border-blue-500"
            placeholder="Search here"
            required
          />
        </div>

        {/* Filter dropdown with reduced width */}
        <div className="relative ml-2 w-[170px]"> {/* Set a smaller width for the dropdown */}
          <Dropdown
            style={{
              background: 'white'
            }}
            className="bg-white"
            label={
              <span className="flex items-center text-black w-full">
                <FaFilter className="mr-2" />
                Filter | {filterOption ? '>50%' : 'All'}
              </span>
            }
            dismissOnClick={false}
          >
            <div className="px-4 py-2">
              <h2 className="text-lg font-semibold">Filter</h2>
              <p className="text-sm text-gray-500">View relevant queries for you</p>
            </div>
            <Dropdown.Item>
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-blue-600"
                  checked={filterOption}
                  onChange={toggleFilterOption}
                />
                <span className="ml-2">50% Match or Higher</span>
              </label>
            </Dropdown.Item>
          </Dropdown>
        </div>

        {/* Hidden filters for mobile, visible only on larger screens */}
        <div className="hidden lg:flex md:flex space-x-2 ml-2"> {/* Show on md and larger */}
          <div className="flex items-center space-x-2">
            <input 
              type="checkbox" 
              checked={filterByNew} 
              onChange={() => { 
                setFilterByNew(!filterByNew); 
                setFilterByDeadline(false); 
                setCurrentPage(1); 
              }} 
              id="newFilter" 
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 dark:bg-blue-700 dark:border-gray-600 dark:focus:ring-blue-500" 
            />
            <label htmlFor="newFilter" className="text-sm font-medium text-black dark:text-white">
              New
            </label>
          </div>

          {/* Ending Soon Filter Checkbox */}
          <div className="flex items-center space-x-2">
            <input 
              type="checkbox" 
              checked={filterByDeadline} 
              onChange={() => { 
                setFilterByDeadline(!filterByDeadline); 
                setFilterByNew(false); 
                setCurrentPage(1); 
              }} 
              id="deadlineFilter" 
              className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500 dark:bg-green-700 dark:border-gray-600 dark:focus:ring-green-500" 
            />
            <label htmlFor="deadlineFilter" className="text-sm font-medium text-black dark:text-white whitespace-nowrap">
              Ending Soon
            </label>
          </div>
        </div>
      </div>
    </form>



    </caption>
    <div className='overflow-x-auto mb-4'>
      <table className="w-full mb-4 text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="px-6 py-3">Generate Pitch</th>
            <th scope="col" className="px-6 py-3">Title & Description</th>
            <th scope="col" className="px-6 py-3">End Date</th>
            <th scope="col" className="px-6 py-3">Match %</th>
            {/* <th scope="col" className="px-6 py-3">DR</th> */}
            <th scope="col" className="px-6 py-3">Journalist</th>
            <th scope="col" className="px-6 py-3">Outlet</th>
            <th scope="col" className="px-6 py-3">Email</th>
          </tr>
        </thead>
        <tbody>
          {fetchedUser === null ? (
            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <td colSpan="8" className="px-6 py-4 text-center text-gray-900 dark:text-white">
                <div className="bg-yellow-100 dark:bg-yellow-800 p-4 rounded-lg border border-yellow-500 dark:border-yellow-600">
                  <div className="flex items-center justify-center mb-3">
                    <IoPerson className="text-yellow-500 text-xl mr-2" />
                    <span className="font-semibold text-lg">Almost there!</span>
                  </div>
                  <p className="mb-3 text-gray-800 dark:text-gray-200">
                    Complete your profile to unlock the database and get matched with the best leads!
                  </p>
                  <a
                    onClick={() => navigate("/dashboard/complete-profile")}
                    className="bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-semibold transition-all duration-300 flex items-center justify-center hover:cursor-pointer"
                  >
                    Complete Profile
                  </a>
                </div>
              </td>
            </tr>
          ) : paginatedListings.length === 0 ? (
            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <td colSpan="7" className="px-6 py-4 text-center text-gray-900 dark:text-white">
                No Matches found
              </td>
            </tr>
          ) : (
            paginatedListings.map((item, index) => (
              
              <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
        <th
              scope="row"
              className="px-6 py-4 font-bold text-gray-900 whitespace-normal dark:text-white bg-white"
            >
              <div>
              <Button className="flex items-center justify-center relative group text-white bg-gradient-to-br from-pink-500 to-orange-400 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800 font-medium rounded-lg text-sm px-5 py-1 text-center me-2 mb-2" onClick={() => handleGenerateClick(item)}>
                <RiAiGenerate className="mr-1 text-lg" /> {/* Adjusted margin and size */}
                <span className="align-middle">Generate</span>
              </Button>
              { selectedItem && openModal ?
                  <Modal show={openModal} onClose={() => setOpenModal(false)} >
                    <Modal.Header>
                      Pitch Generator <span class="bg-pink-100 text-pink-800 text-md font-medium me-2 px-2.5 py-0.5 rounded dark:bg-pink-900 dark:text-pink-300">BETA</span>
                    </Modal.Header>
                    <Modal.Body className="max-h-[70vh] overflow-y-auto">
                      <div className="space-y-6">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-400">Listing Information</label>
                          <p className="mt-1 break-words text-sm text-gray-500 dark:text-gray-400">{selectedItem.listing.description}</p>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-400">Your Expertise</label>
                          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{fetchedUser.expertise}</p>
                        </div>
                        <div>
                          <label htmlFor="content" className="block text-sm font-medium text-gray-700 dark:text-gray-400">Your Reply</label>
                          <textarea
                            id="content"
                            onChange={(e) => setReplyContent(e.target.value)}
                            value={replyContent}
                            placeholder="Put your drafted reply here. Then click generate."
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 h-48 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                          />
                        </div>

                        {/* Display the generated draft */}
                        {loadingEmail ? (
                          <div className="flex justify-center items-center mt-4">
                            <ClipLoader size={50} color="#000" />
                          </div>
                        ) : (
                          generatedDraft && (
                            <div>
                              <label className="block text-sm font-medium text-gray-700 dark:text-gray-400">Generated Draft</label>
                              <textarea
                                id="generated-content"
                                value={generatedDraft}
                                readOnly
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 h-48 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                              />
                            </div>
                          )
                        )}
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                          <div className="flex justify-between w-full items-center">
                            {/* Email Service Buttons */}
                            <div className="flex gap-4">
                              {/* Gmail */}
                              <a
                                href={`https://mail.google.com/mail/?view=cm&fs=1&to=&su=${encodeURIComponent(
                                  "Generated Pitch"
                                )}&body=${encodeURIComponent(generatedDraft || "")}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`text-red-500 text-2xl hover:opacity-75 ${
                                  !generatedDraft && "opacity-50 pointer-events-none"
                                }`}
                              >
                                <FaGoogle />
                              </a>
                              {/* Outlook */}
                              <a
                                href={`https://outlook.office.com/mail/deeplink/compose?subject=${encodeURIComponent(
                                  "Generated Pitch"
                                )}&body=${encodeURIComponent(generatedDraft || "")}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`text-blue-600 text-2xl hover:opacity-75 ${
                                  !generatedDraft && "opacity-50 pointer-events-none"
                                }`}
                              >
                                <FaMicrosoft />
                              </a>
                              {/* Yahoo */}
                              <a
                                href={`https://compose.mail.yahoo.com/?subject=${encodeURIComponent(
                                  "Generated Pitch"
                                )}&body=${encodeURIComponent(generatedDraft || "")}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`text-purple-600 text-2xl hover:opacity-75 ${
                                  !generatedDraft && "opacity-50 pointer-events-none"
                                }`}
                              >
                                <FaYahoo />
                              </a>
                              {/* Copy Button */}
                              <button
                                onClick={() => {
                                  navigator.clipboard.writeText(generatedDraft || "");
                                  alert("Draft copied to clipboard!");
                                }}
                                className={`text-gray-700 text-2xl hover:opacity-75 ${
                                  !generatedDraft && "opacity-50 pointer-events-none"
                                }`}
                                disabled={!generatedDraft}
                              >
                                <FaCopy />
                              </button>
                            </div>

                            {/* Generate Button */}
                            <Button
                              onClick={() =>
                                generateContent(
                                  replyContent,
                                  fetchedUser.expertise,
                                  selectedItem.listing.title
                                )
                              }
                              className="flex items-center bg-black text-white"
                            >
                              <IoCreate className="mr-2" />
                              Generate
                            </Button>
                          </div>
                        </Modal.Footer>

                  </Modal> : ''
                }
          
              </div>
            </th>
              <th
                scope="row"
                className="px-6 py-4 font-bold text-gray-900 whitespace-normal dark:text-white bg-white"
              >
                <div className="relative group">
                  <Link
                      to={`/dashboard/listing/${item.listing._id}`}
                      className="title block text-blue-500 hover:underline"
                  >
                    {item.listing.title.substring(0, 60)}...
                    </Link>
                  <span className="description-trigger text-sm text-gray-500 dark:text-gray-400 cursor-pointer group-hover:underline">
                    {item.listing.description.substring(0, 30)}...
                  </span>
                  <div className="hidden group-hover:block absolute bg-white p-2 border border-gray-300 shadow-lg mt-2 text-sm text-gray-500 dark:text-gray-400 w-96 z-10 left-0">
                    {item.listing.description}
                  </div>
                </div>
              </th>
                <td className="px-6 py-4">
                  {item.listing.deadline && moment(item.listing.deadline, moment.ISO_8601, true).isValid() 
                    ? moment(item.listing.deadline).format('dddd, MMMM Do YYYY') 
                    : 'No deadline'}
                </td>
                <td className="px-6 py-4">
                <div className="flex items-center relative group">
                  <button className={`px-4 py-2 rounded text-white ${getMatchColor(item.matchScore)}`}>
                    {(item.matchScore)}%
                  </button>
                  <FaInfoCircle className="ml-2 cursor-pointer" />
                  <div className="hidden group-hover:block absolute bg-white p-2 border border-gray-300 shadow-lg mt-2 text-sm text-gray-500 dark:text-gray-400 w-96 z-10 left-0 top-full">
                    Explanation: {item.explanation}
                  </div>
                </div>
              </td>
                {/* <td className="px-6 py-4">{item.listing.domainAuthority || 'N/A'}</td> */}
                <td className="px-6 py-4">{item.listing.journalist || 'N/A'}</td>
                <td className="px-6 py-4">{item.listing.publication || 'N/A'}</td>
                <td className="px-6 py-4">{item.listing.email || 'N/A'}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      </div>
      <div className="flex justify-center mt-4">
        <Pagination currentPage={currentPage} totalPages={Math.ceil(filteredListings.length / itemsPerPage)} onPageChange={onPageChange} />
      </div>
    </div>
  );
};

export default Listings;